import React from 'react';

/**
 * Skip to Content link for accessibility
 * Allows keyboard users to skip navigation and jump directly to main content
 */
const SkipToContent: React.FC = () => {
  return (
    <a
      href="#main-content"
      style={{
        position: 'absolute',
        left: '-9999px',
        top: '0',
        zIndex: 9999,
        padding: '1rem 2rem',
        backgroundColor: '#1e3a8a',
        color: 'white',
        textDecoration: 'none',
        fontWeight: 'bold',
        borderRadius: '0 0 8px 0',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}
      onFocus={(e) => {
        e.currentTarget.style.left = '0';
      }}
      onBlur={(e) => {
        e.currentTarget.style.left = '-9999px';
      }}
    >
      Skip to main content
    </a>
  );
};

export default SkipToContent;
